import { render, staticRenderFns } from "./Team-Announcements.vue?vue&type=template&id=4a7b9a3e&scoped=true"
import script from "./Team-Announcements.vue?vue&type=script&lang=js"
export * from "./Team-Announcements.vue?vue&type=script&lang=js"
import style0 from "./Team-Announcements.vue?vue&type=style&index=0&id=4a7b9a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7b9a3e",
  null
  
)

export default component.exports